import { render, staticRenderFns } from "./salesToReview.vue?vue&type=template&id=483f1f68&scoped=true&"
import script from "./salesToReview.vue?vue&type=script&lang=js&"
export * from "./salesToReview.vue?vue&type=script&lang=js&"
import style0 from "./salesToReview.vue?vue&type=style&index=0&id=483f1f68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483f1f68",
  null
  
)

component.options.__file = "salesToReview.vue"
export default component.exports